import { render, staticRenderFns } from "./MediaGroupList.vue?vue&type=template&id=22cf9adf&"
import script from "./MediaGroupList.vue?vue&type=script&lang=js&"
export * from "./MediaGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports